import { devices, theme } from 'styles/theme';
import { css } from 'styled-components';

export const globalStyleBody = css`

    section[aria-live="polite"] {
        position: relative;
        z-index: 99999999999999999999999;
        will-change: unset !important;
    }

    :root {
        view-transition-name: root;
        --vh: 1vh;
    }
    #root {
        min-height: 100vh;
        overflow-x: hidden;
        width: 100%;
    }
    body{
        ${devices.sm}{
            scroll-behavior: smooth !important;
        }
    }
    html,
    body {
        margin: 0;
        padding: 0;
        min-height: 100%;
        width: 100%;
        scroll-behavior: smooth ;
        font-kerning: normal;
        position: relative;
        overflow-x: hidden;
        font-size: 16px;
        line-height: 120%;
        font-weight: 400;
        -webkit-text-size-adjust: 100%;
        text-rendering: geometricPrecision;
        -webkit-font-smoothing: antialiased;
        color: ${({ theme }) => theme.colors.text};
        scrollbar-width: thin;
        font-feature-settings: normal;
        font-variation-settings: normal;
        font-style: normal;
        letter-spacing: -1px;
        scroll-snap-type: y mandatory;
        overscroll-behavior: none;
        &::-webkit-scrollbar {
            display: none;
        }

        &.hidden {
            overflow: hidden;
        }

        ${devices.md} {
            overflow-x: hidden !important;
            overflow-y: scroll !important;
        }
   
    }

    .desktop {
        display: block !important;
        visibility: visible !important;
    }
    

    /* main wrapper after the body and from layout element */

    #smooth-content {
        will-change: transform;
        width: 100%;
        position: relative;
    }
    .container {
        width: 100%;
        max-width: 90%;
        margin: 0 auto;
        padding: 0 20px;
        position: relative;
    }
    
    
    


    //video modal
    .modal.fade .modal-dialog {
        transform: translateX(100%);
    }
    .modal.show .modal-dialog {
        transform: translateX(0);
        @media (max-width: 1024px) {
            transform: translateX(0);
        }
    }
    .main-modal-video.modal-video.modal {
        background: transparent;
    }
    .modal-video {
        background-color: transparent;
        //height: 100vh;
        z-index: 99999;
        padding: 0 !important;
        transition: ${theme.transition};
        .close-button-ygen {
            position: absolute;
            top: 30px;
            right: 30px;
            z-index: 999;
            ${devices.sm} {
                top: 0;
                right: 0;
            }
        }
        &.main-video-modal-wrapper{
            
        }
        &.modal {
            background: white;
        }

        &.moda-eco-sourcing {
            background: #101825;
        }

        .modal-dialog {
            height: 100vh;
            background-color: transparent;
            min-width: 100%;
            margin: 0;

            &::-webkit-scrollbar {
                width: 0;
            }

            /* Track */

            &::-webkit-scrollbar-track {
                background: #f1f1f1;
                display: none;
            }

            /* Handle */

            &::-webkit-scrollbar-thumb {
                background: #888;
                display: none;
            }

            /* Handle on hover */

            &::-webkit-scrollbar-thumb:hover {
                background: #555;
                display: none;
            }
        }

        .modal-body {
            height: 100vh;
        }

        .modal-content {
            background-color: transparent;
        }

        iframe {
            height: 60vh;
            width: 60vw;
            margin: auto;
            position: absolute;
            inset: 0;
        }

        .close-modal {
            position: absolute;
            top: 40px;
            right: 30px;
            height: 30px;
            //cursor: pointer;
            z-index: 99;
        }

        @media (max-width: 768px) {
            .modal-content {
                //padding: 0 20px;

                iframe {
                    width: 90vw;
                    height: 60vh;
                }

                .close-modal {
                    top: 80px;
                    right: 20px;
                }
            }
        }
        @media (max-width: 550px) {
            .modal-content iframe {
                width: 90vw;
                height: 40vh;
            }
        }
    }
 
    
    
    
    
    //responsive
    ${devices.xxl} {
        .container {
            max-width: 85%;
            padding: 0 20px;
        }
    }
    ${devices.ResponsiveTab} {
        .container,
        .container-lg,
        .container-md,
        .container-sm {
            max-width: 100%;
            padding: 0 15px;
        }
    }
    ${devices.sm} {
        .container,
        .container-sm {
            max-width: 100%;
            padding: 0 15px;
        }
    }
        
`;
